module.exports = __webpack_public_path__ + "img/stock1.22a67e1d.png";